// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PreviewInfo_previewInfo__Cx13S {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.PreviewInfo_infoBadge__IkBvu {
  padding: 4px 12px;
  background-color: #edf2f7;
  border-radius: 12px;
  font-size: 12px;
  color: #4a5568;
  border: 1px solid #e2e8f0;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/PreviewTesterHome/PreviewTester/components/PreviewInfo.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".previewInfo {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n  flex-wrap: wrap;\n}\n\n.infoBadge {\n  padding: 4px 12px;\n  background-color: #edf2f7;\n  border-radius: 12px;\n  font-size: 12px;\n  color: #4a5568;\n  border: 1px solid #e2e8f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewInfo": `PreviewInfo_previewInfo__Cx13S`,
	"infoBadge": `PreviewInfo_infoBadge__IkBvu`
};
export default ___CSS_LOADER_EXPORT___;
